<template>
	<div class="content-page content-page--laser-form-read-only">
		<ActionSetNav
			v-if="navigatingFromCustomer && pageTitle"
			:name="pageTitle"
			:display="true"
			:actions="mainNavActions"
			ref="customerNav"
		/>
		<div class="content-page__heading">
			<div class="content-page__breadcrumb-title">
				<Breadcrumbs :items="urlNames" />
				<h2 class="content-page__title">Form Details</h2>
			</div>

			<div class="content-page__action" v-show="hasUpdatePermission">
				<Button
					labelText="Edit in Designer"
					:btnClick="editForm"
					:iconBeforeLabel="true"
				/>
			</div>
		</div>

		<!-- DEV NOTES: BlockNotifications component is missing the option to display the status icon based on notification requirement. -->
		<BlockContainer>
			<BlockNotifications
				title="Shared Form"
				message="This form is shared by multiple clients. Changes will be applied to the form for all assigned clients.
				If changes are unique to one client, create a copy of this form from the Forms Manager for the specific client."
			/>
		</BlockContainer>
		<Spinner :processor="{ loading: loadingSource }" />
		<div v-if="hasFormValue">
			<LaserDetails
				@hasErrors="val => (hasErrorModal = val)"
				v-model="form"
			/>
		</div>
	</div>
</template>

<script>
import ActionSetNav from '@/site-components/actions-set/action-set-nav';
import Button from '@/components/forms/button/button';
import BlockContainer from '@/components/notifications/block-notifications/block-notifications-container';
import BlockNotifications from '@/components/notifications/block-notifications/block-notifications';
import Spinner from '@/components/visual/spinner/spinner';
import LaserDetails from '@/views/form-designer/laser-details.vue';
import Breadcrumbs from '@/components/shells/breadcrumbs/breadcrumbs';
import FormsReadonlyMixins from '@/mixins/forms/forms_readonly';

export default {
	components: {
		ActionSetNav,
		Button,
		BlockContainer,
		BlockNotifications,
		Breadcrumbs,
		Spinner,
		LaserDetails
	},
	name: 'LaserFormDesignerReadOnly',
	mixins: [FormsReadonlyMixins]
};
</script>

<style lang="scss" scoped>
/**
  * [Description]
  *
  * Laser Form details
  * Can use SCSS variables = TRUE
  *
  *
**/

.content-page {
	@include mq($until: md) {
		margin: 0;
		&__heading {
			margin: $gutter-xl $gutter-md;
		}
	}
	&__action {
		@include mq($until: md) {
			width: 100%;
			display: flex;
			justify-content: flex-end;
		}
	}
}
</style>
